import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../services/api/api.service';

@Component({
  selector: 'app-auth-subdomain',
  templateUrl: './auth-subdomain.component.html',
  styleUrls: ['./auth-subdomain.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        padding: '.75rem 1.25rem',
        margin: '0 0 1rem 0'
      })),
      state('out', style({
        opacity: '0',
        height: '0px',
        width: '0px'
      })),
      transition('in <=> out', animate('0.1s'))
    ])
  ]
})
export class AuthSubdomainComponent {

  errorDisplay: string = 'out';
  errorMsg:string;
  loading: boolean = false;
  currentYear:any;
  subdomainName: string = "";
  domain: string = environment.CLIENT_URL;
  env = environment;

  constructor(
    private apiService: ApiService
  ) 
  {
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  }

  ngOnInit(){
  }

  login(){
    this.loading = true;
    this.errorDisplay = 'out';
    this.errorMsg = null;
    
    this.apiService.checkSubdomain(this.subdomainName).subscribe(result => {
      this.loading = false;
      if (result?.result.verified){
        this.errorDisplay = 'in';
        this.errorMsg = result?.message;
      }
      else {
        this.errorDisplay = 'out';
        this.errorMsg = null;
        const newUrl = `${environment.HTTP}${this.subdomainName}.${environment.CLIENT_URL}`;
        window.location.href = newUrl;
      }
    }, (error) => {
      // console.log(error);
      this.loading = false;
      this.errorDisplay = 'in';
      this.errorMsg = error?.error?.message;
    })
  }
}
